import { Field, useField } from "formik";
import { CustomInput, Form } from "taltech-styleguide";
import { FeedbackMessage } from "./FeedbackMessage";
import { InputRadioProps, TTFormInputProps } from "./input.types";
import { InputBase } from "./InputBase";
import { di } from "@dirootie-core/di";

export const InputRadio = ({
  inline = true,
  id,
  fieldId,
  label = di.str.startCase(id),
  showLabel = true,
  elementClass,
  value,
  ...props
}: {
  inline?: boolean;
  value: any;
  fieldId: string;
  onClick?: any;
  checked?: boolean;
} & TTFormInputProps) => {
  const [field, meta, helpers] = useField(fieldId);
  const inputProps: any = {
    ...props,
    type: "radio" as const,
    value: value,
    name: id,
    label,
    inline,
    checked: props.checked,
  };
  const result = (
    <Form.Group className={elementClass}>
      <Field
        {...inputProps}
        role="group"
        component={CustomInput}
        onClick={(e: any) => {
          helpers.setValue(e.target.value);
          if (props.onClick) {
            props.onClick(e);
          }
        }}
      />
      <FeedbackMessage fieldId={id}></FeedbackMessage>
    </Form.Group>
  );
  return result;
};

export const InputRadioGroup = ({
  inline = true,
  id,
  label = di.str.startCase(id),
  showLabel = true,
  showOptLabel = true,
  elementClass,
  options = [],
  ...props
}: { inline?: boolean } & TTFormInputProps & {
    options: any[];
    showOptLabel?: boolean;
  }) => {
  const [field, meta, helpers] = useField(id);
  const inputProps = {
    ...props,
    type: "radio" as const,
    fieldId: id,
    name: id,
    inline,
    role: "group",
  };
  const result = (
    <Form.Group className={elementClass}>
      {showLabel && (
        <Form.Label className={"d-flex align-items-center"}>{label}</Form.Label>
      )}
      <div className="d-flex gap-3 flex-wrap">
        {options.map((el: { value: string; text: any }, index) => {
          return (
            <InputRadio
              key={index}
              value={el.value}
              label={showOptLabel ? el.text : ""}
              id={id}
              checked={field.value === el.value}
              {...inputProps}
            />
          );
        })}
      </div>
    </Form.Group>
  );
  return result;
};
